import React from "react";
import parse from "html-react-parser";
import {
  CourseTaskDocs,
  CourseTaskFooter,
  CourseTaskTheory,
  CourseTaskTrading,
  CourseTaskVideo,
  FileUploader,
} from ".";
import { CommonProgressBar, ModalLayout, SpinnerComponent } from "shared";
import fullscreenIcons from "assets/images/icons/fullscreen.svg";
import flagIcon from "assets/images/icons/flag-icon.svg";
import shocking from "assets/images/shocking-sale.svg";
import actElseWhere from "assets/images/act_elseWhere.png";
import { Link } from "react-router-dom";
import { useImmer } from "use-immer";
import { useServerTime, useTaskExtendedInfo } from "../hooks";
import moment from "moment";
import { useAppScope } from "master";
import { accountElseWhereText } from "..";

export const CourseTaskView = ({
  title = "",
  isPending = false,
  description = "",
  taskGroup,
  taskSections,
  taskContents,
  courseType,
  currentCourseTask,
  onStartSimulation,
  updateCourseTasksStatus,
  isMobile = false,
  currentCourseTaskIndex,
  onPrevTask,
  onNextTask,
  isLastTask,
  modalState,
  onCloseModal,
  onOpenModal,
  remainingAttempts,
  maxAttempt,
  completionPercentage,
  onExternalAccess
}) => {
  const [pdfFilePath, setPdfFilePath] = useImmer(false);
  const { isMWCD, lanSettings } = useAppScope();

  const {
    id: studentTaskId,
    courseTaskId,
    taskGroup: currentTaskGroup,
  } = !!currentCourseTask && currentCourseTask;

  const isTheory = currentTaskGroup === 1;
  const isVideo = currentTaskGroup === 2;
  const isDocument = currentTaskGroup === 3;
  const isTrading = currentTaskGroup === 4;
  const isFileUploading = currentTaskGroup === 5;

  const { data } = useServerTime({ load: isTrading });

  const taskExtendedInfo = useTaskExtendedInfo({
    load: isTrading || isFileUploading,
    courseTaskId,
    studentTaskId,
    taskGroup: currentTaskGroup,
  });

  const { data: taskExtendedData, isLoading } = taskExtendedInfo;

  const { fileUploads } = !isLoading && isFileUploading && taskExtendedData;
  const { startDate, endDate, initialHolding } =
    !isLoading && isTrading && taskExtendedData;

  const currentDate = data?.split("T")[0];
  const start = startDate?.split("T")[0];
  const end = endDate?.split("T")[0];

  const isStart =
    start && currentDate ? moment(start).isSameOrBefore(currentDate) : false;
  const isEnd =
    end && currentDate ? moment(end).isSameOrAfter(currentDate) : false;
  const isDisabled = isTrading
    ? isEnd
      ? isStart
      : end
        ? !isStart
        : isStart
    : true;
  const label = !isEnd && end ? "View" : "Start";
  const isCompletionPercentageZero = completionPercentage === 0.0;
  const isFileUploadsEmpty = fileUploads?.length === 0;

  return (
    <div
      className={`col-12 single-page-content-block course-task-view ${!isMobile && "col-md-8"
        }`}
    >
      <div className={`content-wrapper ${isMWCD ? "reduced-height" : ""}`}>
        <div className="content-block tasks-content scrollbar-style px-0">
          {isPending ? (
            <SpinnerComponent />
          ) : (
            <>
              {!isFileUploading && (
                <div className="mb-3 pb-3 course-view-div">
                  <div className="d-flex justify-content-between align-items-center">
                    <h3>{title}</h3>
                    {isDocument && pdfFilePath && (
                      <Link
                        className="pdf-fullscreen-btn"
                        to={`/contents/${pdfFilePath}`}
                        target="_blank"
                      >
                        <img src={fullscreenIcons} alt="" />{" "}
                        <span>Full Screen Mode</span>
                      </Link>
                    )}
                  </div>
                  {(!!maxAttempt ||
                    !!completionPercentage ||
                    isCompletionPercentageZero) && (
                      <div className="d-flex align-items-center justify-content-start">
                        {!!maxAttempt && (
                          <>
                            <img src={flagIcon} alt="" />
                            <span className="ms-3">
                              No. of attempts: {remainingAttempts}/{maxAttempt}
                            </span>
                            <span className="mx-3 course-view-div-dot text-large">
                              &#x2022;
                            </span>
                          </>
                        )}
                        {(!!completionPercentage ||
                          isCompletionPercentageZero) && (
                            <div className="course-view-div-preogress">
                              <CommonProgressBar
                                width={completionPercentage}
                                label={completionPercentage + "%"}
                              />
                            </div>
                          )}
                      </div>
                    )}
                </div>
              )}
              {description && !isFileUploading && (
                <div className="course-view-div">{parse(description)}</div>
              )}
              {isTheory &&
                taskSections?.length > 0 &&
                taskSections?.map((elem, index) => {
                  return (
                    <CourseTaskTheory
                      key={elem?.key}
                      title={elem?.title}
                      description={elem?.description}
                      sectionContents={elem?.sectionContents}
                      taskSections={taskSections}
                      index={index}
                    />
                  );
                })}
              {isVideo && (
                <div style={{ maxWidth: "1000px" }} className="course-view-div">
                  {taskContents?.length > 0 &&
                    taskContents?.map((elem) => {
                      return (
                        <CourseTaskVideo
                          key={elem?.key}
                          contentType={elem?.contentType}
                          fileURL={elem?.fileURL}
                        />
                      );
                    })}
                </div>
              )}
              {isDocument &&
                taskContents?.length > 0 &&
                taskContents?.map((elem, index) => {
                  return (
                    <CourseTaskDocs
                      key={elem?.key}
                      index={index}
                      taskContents={taskContents}
                      contentType={elem?.contentType}
                      fileURL={elem?.fileURL}
                      setPdfFilePath={setPdfFilePath}
                    />
                  );
                })}
              {isTrading && (
                <CourseTaskTrading
                  startDate={startDate}
                  initialHolding={initialHolding}
                  endDate={endDate}
                />
              )}

              {isFileUploading && (
                <FileUploader
                  currentCourseTask={currentCourseTask}
                  description={description}
                  title={title}
                  taskExtendedData={taskExtendedData}
                  isLoading={isLoading}
                />
              )}
            </>
          )}
        </div>
        <CourseTaskFooter
          courseType={courseType}
          taskGroup={taskGroup}
          isPending={isPending}
          currentCourseTask={currentCourseTask}
          updateCourseTasksStatus={updateCourseTasksStatus}
          onStartSimulation={onStartSimulation}
          isMobile={isMobile}
          currentCourseTaskIndex={currentCourseTaskIndex}
          onPrevTask={onPrevTask}
          onNextTask={onNextTask}
          isLastTask={isLastTask}
          isDisabled={isDisabled}
          label={label}
          remainingAttempts={remainingAttempts}
          maxAttempt={maxAttempt}
          modalState={modalState}
          onCloseModal={onCloseModal}
          onOpenModal={onOpenModal}
          isFileUploadsEmpty={isFileUploadsEmpty}
          onExternalAccess={onExternalAccess}
        />
      </div>

      {modalState.isOpen && modalState.actionFrom === "forbidden" && (
        <ModalLayout
          isOpen={modalState.isOpen}
          title={accountElseWhereText.title[lanSettings?.lan || "en"]}
          message={accountElseWhereText.message[lanSettings?.lan || "en"]}
          onConfirm={onCloseModal}
          onCancel={onCloseModal}
          confirmButtonLabel={accountElseWhereText.tryAgain[lanSettings?.lan || "en"]}
          icon={actElseWhere}
        />
      )}
    </div>
  );
};
